import styled from 'styled-components'

const OpinionContainer = styled.div`
  position: relative;
  grid-area: opinions;
  align-self: center;
  width: 100%;
`
export default OpinionContainer



// WEBPACK FOOTER //
// ./src/components/containers/wizard/OpinionContainer.tsx